/*
 * @Author: your name
 * @Date: 2019-11-21 17:14:16
 * @LastEditTime : 2020-01-04 10:54:20
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vue/wei/src/main.js
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;
// import Vconsole from "vconsole";
// new Vconsole();
Vue.prototype.$titles = "源思维能力测评|自适应测评，超越自我，成就自我。";
Vue.prototype.$imgurls = `https://${
  window.location.host
  }${require("./assets/share.jpg")}`;
Vue.prototype.$descs = "测一测，学习更有方向！";

import {
  Cell,
  CellGroup,
  Row,
  Col,
  Button,
  List,
  Search,
  Image,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  Dialog,
  Circle,
  Progress,
  Icon,
  Rate,
  Toast,
  Divider,
  Popup,
  Tag,
  Overlay,
  NavBar
} from "vant";
Vue.use(Cell)
  .use(CellGroup)
  .use(Row)
  .use(Col)
  .use(Button)
  .use(List)
  .use(Search)
  .use(Image)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Radio)
  .use(RadioGroup)
  .use(Dialog)
  .use(Circle)
  .use(Progress)
  .use(Icon)
  .use(Rate)
  .use(Toast)
  .use(Divider)
  .use(Popup)
  .use(Tag)
  .use(Overlay)
  .use(NavBar);
import "view-design/dist/styles/iview.css";
import { Table } from "view-design";
Vue.component("Table", Table);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
